module.exports = __webpack_public_path__ + "assets/companies-2575c35b00d1f3c61e5582af609e4e6d.svg";